// extracted by mini-css-extract-plugin
export var button = "SliderNavigation-module--button--1zN-w";
export var buttonNext = "SliderNavigation-module--buttonNext--1YlVQ";
export var buttonPrev = "SliderNavigation-module--buttonPrev--1ma9a";